class heroSlider extends HTMLElement {
  constructor() {
    super();

    let bannerSwiper = new Swiper('[data-hero-slider]', {
      slidesPerView: 1, 
      loop: true,
      effect: 'slide',
      speed: 1000,
      navigation: {
        nextEl: '.hero__button-next',
        prevEl: '.hero__button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    });
  }
}
customElements.define('hero-slider', heroSlider);